import { useState } from "react";
import { getPage } from "@/shared/model/pages-management/AllPages.ts";
import type TabState from "@/pages/human-resources/time-management/components/schedule-palette/model/TabState.ts";
import useScheduleViewState from "@/pages/human-resources/time-management/model/schedule-view/useScheduleViewState.ts";

export default function useTabsState(): TabState {
  const {
    palette: { view },
  } = useScheduleViewState();
  const [scheduleTemplateSearchInput, setScheduleTemplateSearchInput] =
    useState("");
  const [dailyTagSearchInput, setDailyTagSearchInput] = useState("");
  const [positionSearchInput, setPositionSearchInput] = useState("");

  switch (view) {
    case "templates":
      return {
        searchInput: scheduleTemplateSearchInput,
        setSearchInput: setScheduleTemplateSearchInput,
        settingsPage: getPage("rh_planningtemplate_view"),
      };
    case "tags":
      return {
        searchInput: dailyTagSearchInput,
        setSearchInput: setDailyTagSearchInput,
        settingsPage: getPage("rh_planningparams_tagsview"),
      };
    case "positions":
      return {
        searchInput: positionSearchInput,
        setSearchInput: setPositionSearchInput,
        settingsPage: getPage("rh_rhposte_list"),
      };
  }
}
